var React = require('react');

function KbdEject (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M0 15v-3h16v3H0zm0-6l7.995-8L16 9H0z"}));
}

KbdEject.defaultProps = {"viewBox":"0 0 16 16"};

module.exports = KbdEject;

KbdEject.default = KbdEject;
